import { lazy } from 'react';

import { FederatedModule } from '@zenbusiness/application-commons-federation';
import {
  Route,
  Outlet
} from 'react-router-dom';

import Error from '#client/components/ErrorBoundary/Error';
import Loading from '#client/components/LoadingV2';
import { ROUTES, FEDERATED } from '#client/manifest';
import SmartNavigate from '#client/routes/SmartNavigate';
import timeout from '#client/utils/timeout';

const MoneyZenDash = lazy(() => timeout(import(/* webpackChunkname: 'money' */'#client/pages/Money')));

const fedProps = {
  loadingElement: <Loading />,
  errorElement: <Error />
};

function routes(useUi) {
  if (useUi) {
    return (
      <>
        <Route path="money" element={<FederatedModule {...fedProps} {...FEDERATED.MoneyUi} exportName="Money" />} />
        <Route path="money/:page" element={<FederatedModule {...fedProps} {...FEDERATED.MoneyUi} exportName="Money" />} />
      </>
    );
  }

  return (
    <>
      <Route path="money" element={<Outlet />}>
        <Route index element={<MoneyZenDash />} />
        <Route path=":page" element={<MoneyZenDash />} />

        <Route path="*" element={<SmartNavigate replace to={ROUTES.moneyLandingPage} />} />
      </Route>
    </>
  );
}

export default routes;
